import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import {
  useHasOrders,
  useHasSession,
  useSessionId,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import useIsWaiter from "@/shared/hooks/useIsWaiter";
import { useCart } from "@/shared/hooks/useCartHook";
import useUnsavedPrinterMutation from "@/shared/mutations/printReceipt/useUnsavedPrinterMutation";
import usePosOrderSubmitDataHook from "@/shared/hooks/usePosOrderSubmitDataHook";
import useOrderSessionReceiptQuery from "@/shared/queries/orderssessions/useOrderSessionReceiptQuery";
import usePrint from "@/shared/hooks/usePrint";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import { useCallback } from "react";

const usePrintReceiptAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const isWaiter = useIsWaiter();
  const hasSession = useHasSession();
  const hasOrders = useHasOrders();
  const sessionId = useSessionId();
  const [cart] = useCart();
  const printReceipt = useOrderSessionReceiptQuery();
  const printOnTheFly = useUnsavedPrinterMutation();
  const submitData = usePosOrderSubmitDataHook();
  const print = usePrint();

  const handlePrint = useCallback(() => {
    printReceipt.mutateAsync({ sessionId: sessionId }).then((data) => {
      print(data);
    });
  }, [sessionId, printReceipt, print]);

  const handleOnTheFlyPrint = useCallback(() => {
    printOnTheFly.mutateAsync(submitData({ onTheFlyPrinting: true }));
  }, [printOnTheFly, submitData]);

  return {
    name: "printReceipt" as CurrentActionTypes,
    label: t("posOrders.printReceipt"),
    set: () =>
      hasSession && hasOrders
        ? handlePrint()
        : cart?.length
          ? handleOnTheFlyPrint()
          : null,
    instantSet: true,
    filtered: false /* !isWaiter */,
    disabled: false,
    iconVariant: "printer",
  };
};

const PrintReceiptAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = usePrintReceiptAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default PrintReceiptAction;
